module.exports = __webpack_public_path__ + "0dedf5dc0842faa7f59b0c8c71a2db2e.ttf";